/**
 * KAN-746: API раздела "Заказы" интернет-магазина. Контракт: types/order.ts.
 * Ошибки переходов и правок приходят 400/403/409 {"detail"}.
 */
import apiClient from './client';
import type {
  OrderAction,
  OrderCounts,
  OrderDetail,
  OrderItemsPatch,
  OrdersListParams,
  OrdersListResponse,
} from '@/types/order';

const BASE = '/api/v1/orders/';

/** Пустые фильтры в запрос не уходят. */
function cleanParams(params: OrdersListParams): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') out[key] = value;
  });
  return out;
}

export const ordersApi = {
  list: async (params: OrdersListParams): Promise<OrdersListResponse> =>
    (await apiClient.get<OrdersListResponse>(BASE, { params: cleanParams(params) })).data,
  counts: async (): Promise<OrderCounts> =>
    (await apiClient.get<OrderCounts>(`${BASE}counts/`)).data,
  get: async (id: string): Promise<OrderDetail> =>
    (await apiClient.get<OrderDetail>(`${BASE}${encodeURIComponent(id)}/`)).data,
  /** Новый заказ клиента (или его текущий черновик). */
  create: async (clientId: string): Promise<OrderDetail> =>
    (await apiClient.post<OrderDetail>(BASE, { client_id: clientId })).data,
  patchItems: async (id: string, patch: OrderItemsPatch): Promise<OrderDetail> =>
    (await apiClient.patch<OrderDetail>(`${BASE}${encodeURIComponent(id)}/items/`, patch)).data,
  transition: async (id: string, action: OrderAction): Promise<OrderDetail> =>
    (await apiClient.post<OrderDetail>(`${BASE}${encodeURIComponent(id)}/${action}/`)).data,
  /** KAN-755: применить промокод; 400 {"detail"}: не найден или не действует. */
  applyPromo: async (id: string, code: string): Promise<OrderDetail> =>
    (await apiClient.post<OrderDetail>(`${BASE}${encodeURIComponent(id)}/promo/`, { code })).data,
  /** KAN-755: снять промокод. */
  removePromo: async (id: string): Promise<OrderDetail> =>
    (await apiClient.delete<OrderDetail>(`${BASE}${encodeURIComponent(id)}/promo/`)).data,
};
